import React, { useMemo } from 'react';
import classNames from 'classnames';
import { isImage, isPdf } from 'utils';
import { PdfViewer } from 'components/PdfViewer';
import ResolveImage from 'components/ResolveImage';
import { SIZE } from 'models/Size';
import { SpecialZoomLevel } from '@react-pdf-viewer/core';
import MymeTypeIcon from 'router/subrouters/DataRoom/components/DataRoomDocumentsRouter/components/MymeTypeIcon';
import { FilePreview as FilePreviewType } from 'models/File';

import './FilePreview.styles.scss';

type FilePreviewProps = {
  className?: string;
} & FilePreviewType;

const FilePreview: React.FC<FilePreviewProps> = (props) => {
  const { className, url, type } = props;

  const classes = classNames('file-preview', type, className);

  const showFilePreview = useMemo(
    () => url && (isImage(type) || isPdf(type)),
    [type, url],
  );

  return (
    <div className={classes}>
      <div className="wrapper">
        {showFilePreview ? (
          isImage(type) ? (
            <ResolveImage
              src={url}
              alt="Image preview"
              loaderSize={SIZE.SMALL}
            />
          ) : (
            <PdfViewer
              url={url}
              canZoom={false}
              loaderSize={SIZE.SMALL}
              defaultScale={SpecialZoomLevel.PageWidth}
              renderError={() => <MymeTypeIcon mimeType={type} />}
            />
          )
        ) : (
          <MymeTypeIcon mimeType={type} />
        )}
      </div>
    </div>
  );
};

export default FilePreview;
